<script>
// A page's main action ("Ajouter…"), given to its header (the settings', the business
// intelligence's), which shows it on phones as the "+" of docs/page-layout.md. It draws nothing
// itself; larger screens keep the page's own labelled button.
export default {
  name: 'PageMainAction',
  inject: { pageHeader: { default: null } },
  props: {
    label: { type: String, required: true },
    icon: { type: String, default: 'plus' },
  },
  computed: {
    action() {
      return { label: this.label, icon: this.icon, run: () => this.$emit('click') };
    },
  },
  watch: {
    action(action) {
      if (this.pageHeader) this.pageHeader.setAction(action);
    },
  },
  mounted() {
    if (this.pageHeader) this.pageHeader.setAction(this.action);
  },
  beforeDestroy() {
    if (this.pageHeader) this.pageHeader.clearAction(this.action);
  },
  // A page kept alive (Concurrents) gives it back when shown again, and takes it away when left.
  activated() {
    if (this.pageHeader) this.pageHeader.setAction(this.action);
  },
  deactivated() {
    if (this.pageHeader) this.pageHeader.clearAction(this.action);
  },
  render() {
    return null;
  },
};
</script>
